import httpApiApplication from '../../../../http/httpApiApplication';
import { type EnrollmentTaxPayerInfo, type TemplateWeb } from '../types';

export const base = '/taxpayerrequest';
export const baseEnrollment = '/taxpayerrequest/EnrollmentRequests';

export const saveTaxypayerRequest = (request: {
  info: EnrollmentTaxPayerInfo;
  captcha: { DNTCaptchaInputText: string; DNTCaptchaText: string; DNTCaptchaToken: string };
}) => {
  const { info, captcha } = request;
  return httpApiApplication.post(baseEnrollment, { data: info, ...captcha });
};

export const updateTaxypayerRequest = (id: string, request: EnrollmentTaxPayerInfo) => {
  return httpApiApplication.put(`${baseEnrollment}/${id}`, request);
};

export const getNotes = (section: string, language: string): Promise<TemplateWeb> => {
  return httpApiApplication.get(`${base}/notes/${section}?language=${language}`);
};
